import React, { useState, useEffect } from "react";
import "@fontsource/poppins/400.css";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config";

import "../Properties/properties.css";
import PropertyComponent from "../../components/PropertyComponent";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import OpenHouseTimesModal from "../../components/OpenHouseTimesModal";
import ShareComponent from "../../components/ShareComponent/ShareComponent";
import "../Header/Header.css";
import Balls from "../Templates/Loading";
import { getApi, putApi } from "../AppApis";
import Header from "../Header/Header";
import { GoArrowUpRight } from "react-icons/go";
import EditProperty from "./EditProperty";
import PropertySkeleton from "./PropertySkeleton";

const MyProperties = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [properties, setProperties] = useState([]);
    const [isOpenhouseModal, setIsOpenhouseModal] = useState(false);
    const [isShareModal, setIsShareModal] = useState(false);

    const [showModal, setShowModal] = useState(false);

    // Loading state
    const [loading, setLoading] = useState(false);

    // Property
    const [property, setProperty] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isFirstTimeLoaded, setIsFirstTimeLoaded] = useState(true);
    const [completeProperties, setCompleteProperties] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);

    const [sortOption, setSortOption] = useState("newest");
    const [currentProperties, setCurrentProperties] = useState(null);
    const [selectedTab, setSelectedTab] = useState("all");

    useEffect(() => {
        if (property) {
            setProperties((prev) => prev.map((p) => (p?.property_id === property?.property_id ? { ...p, ...property } : p)));
        }
    }, [property]);

    const sortProperties = (properties, sortOption) => {
        switch (sortOption) {
            case "newest":
                return properties?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            case "oldest":
                return properties?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            case "priceLowHigh":
                return properties?.sort((a, b) => a.price - b.price);
            case "priceHighLow":
                return properties?.sort((a, b) => b.price - a.price);
            default:
                return properties;
        }
    };

    useEffect(() => {
        fetchProperties();
    }, []);

    useEffect(() => {
        if (properties.length > 0) {
            const sortedProperties = sortProperties(properties, sortOption);
            setProperties(sortedProperties);
        }
    }, [sortOption]);

    const fetchProperties = async () => {
        try {
            setLoading(true);
            const response = await getApi(`/properties/list_user_properties`);
            if (response?.error === 401) {
                // throw new Error(data.error);
                navigate("/login");
            } else {
                const data = response.response.data.map((item) => item.current_property);
                setCompleteProperties(response.response.data);
                if (state?.property_id && isFirstTimeLoaded) {
                    let findProperty = data.find((item) => item.property_id === state.property_id);
                    console.log("findProperty", { findProperty, state });
                    if (findProperty) {
                        setProperty(findProperty);

                        setShowModal(true);
                        setIsEdit(true);
                        setIsFirstTimeLoaded(false);
                    }
                }
                const sortedProperties = sortProperties(data, sortOption);
                setProperties(sortedProperties);
                const findProperty = sortedProperties.find((item) => property?.property_id === item?.property_id);
                setCurrentProperties(sortedProperties);
                localStorage.setItem("propertiesData", JSON.stringify(sortedProperties));
            }
        } catch (error) {
            console.error("Error fetching properties:", error);
            setProperties([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedTab === "pending") {
            setCurrentProperties(properties.filter((property) => property.status === "pending_review"));
        } else if (selectedTab === "active") {
            setCurrentProperties(properties.filter((property) => property.status === "approved"));
        } else if (selectedTab === "rejected") {
            setCurrentProperties(properties.filter((property) => property.status === "rejected"));
        } else {
            setCurrentProperties(properties);
        }
    }, [selectedTab]);

    useEffect(() => {
        document.title = `My Properties | ${config.get("COMPANY_NAME")}`;
    }, []);

    const handleTabChange = (val) => {
        setSelectedTab(val);
    };

    let propertyCurrent = completeProperties.filter((item) => item.pending_version?.property_id === selectedProperty?.property_id)[0]?.pending_version;
    return (
        <>
            <div className="tw-overflow-x-hidden">
                <div className="tw-h-screen tw-bg-white tw-overflow-y-scroll tw-overflow-x-hidden ">
                    <Header title={"My Properties"} />

                    {loading ? (
                        <div className="tw-gap-5 tw-mx-auto md:tw-mt-[70px]">
                            {/* Skeleton for tab buttons */}
                            <div className="tw-flex tw-w-full tw-justify-between tw-p-2 tw-bg-background_color tw-mb-5 tw-px-5">
                                <div className="tw-p-2 tw-px-5 tw-bg-white tw-rounded-lg tw-flex tw-gap-5">
                                    {[1, 2, 3, 4].map((_, index) => (
                                        <div key={index} className="tw-flex tw-items-center tw-gap-2">
                                            <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-12 tw-animate-pulse"></div>
                                            <div className="tw-w-6 tw-h-6 tw-bg-gray-200 tw-rounded-full tw-animate-pulse"></div>
                                        </div>
                                    ))}
                                </div>
                                <div className="tw-hidden md:tw-flex tw-gap-4 tw-items-center">
                                    <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-16 tw-animate-pulse"></div>
                                    <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-20 tw-animate-pulse"></div>
                                </div>
                            </div>

                            {/* Skeleton for property grid */}
                            <section className="tw-px-5 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-content-center xl:tw-grid-cols-4 2xl:tw-grid-cols-4 tw-gap-[1.5rem] 2xl:tw-gap-[2.5rem] tw-pb-20 tw-w-full">
                                {[...Array(8)].map((_, index) => (
                                    <PropertySkeleton key={index} />
                                ))}
                            </section>
                        </div>
                    ) : (
                        <div className="tw-gap-5 tw-mx-auto md:tw-mt-[70px]">
                            <div className="tw-flex tw-w-full tw-justify-between tw-p-2 tw-bg-background_color tw-mb-5 tw-px-2 sm:tw-px-5 tw-gap-2 md:tw-gap-4">
                                <div className="Filterss tw-flex tw-items-center tw-overflow-x-auto">
                                    <div className="tw-p-2 tw-px-5 tw-bg-white tw-rounded-lg tw-flex tw-gap-1 sm:tw-gap-2 md:tw-gap-5 tw-text-[12px] sm:tw-text-[14px] md:tw-text-[16px] tw-min-w-max">
                                        <button
                                            onClick={() => handleTabChange("all")}
                                            className={`tw-px-2 md:tw-px-3 tw-rounded-md tw-py-1 tw-flex tw-gap-1 sm:tw-gap-2 tw-items-center tw-whitespace-nowrap tw-transition-all tw-duration-200 ${
                                                selectedTab === "all"
                                                    ? "tw-text-primary tw-font-semibold tw-border-b-2 tw-border-primary tw-bg-primary/5"
                                                    : "tw-text-black hover:tw-bg-gray-50"
                                            }`}
                                            aria-current={selectedTab === "all" ? "page" : undefined}
                                            role="tab"
                                            aria-selected={selectedTab === "all"}
                                        >
                                            All
                                            <div className="tw-w-[18px] sm:tw-w-[20px] md:tw-w-[25px] tw-h-[18px] sm:tw-h-[20px] md:tw-h-[25px] tw-text-[10px] sm:tw-text-[12px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-blue-500 tw-text-white tw-font-medium">
                                                {properties?.length || 0}
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabChange("active")}
                                            className={`tw-px-2 md:tw-px-3 tw-py-1 tw-rounded-md tw-flex tw-gap-1 sm:tw-gap-2 tw-items-center tw-whitespace-nowrap tw-transition-all tw-duration-200 ${
                                                selectedTab === "active"
                                                    ? "tw-text-primary tw-font-semibold tw-border-b-2 tw-border-primary tw-bg-primary/5"
                                                    : "tw-text-black hover:tw-bg-gray-50"
                                            }`}
                                            aria-current={selectedTab === "active" ? "page" : undefined}
                                            role="tab"
                                            aria-selected={selectedTab === "active"}
                                        >
                                            Active
                                            <div className="tw-w-[18px] sm:tw-w-[20px] md:tw-w-[25px] tw-h-[18px] sm:tw-h-[20px] md:tw-h-[25px] tw-text-[10px] sm:tw-text-[12px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-[#28A745] tw-text-white tw-font-medium">
                                                {properties.filter((property) => property.status === "approved").length}
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabChange("pending")}
                                            className={`tw-px-2 md:tw-px-3 tw-py-1 tw-rounded-md tw-flex tw-gap-1 sm:tw-gap-2 tw-items-center tw-whitespace-nowrap tw-transition-all tw-duration-200 ${
                                                selectedTab === "pending"
                                                    ? "tw-text-primary tw-font-semibold tw-border-b-2 tw-border-primary tw-bg-primary/5"
                                                    : "tw-text-black hover:tw-bg-gray-50"
                                            }`}
                                            aria-current={selectedTab === "pending" ? "page" : undefined}
                                            role="tab"
                                            aria-selected={selectedTab === "pending"}
                                        >
                                            Pending
                                            <div className="tw-w-[18px] sm:tw-w-[20px] md:tw-w-[25px] tw-h-[18px] sm:tw-h-[20px] md:tw-h-[25px] tw-text-[10px] sm:tw-text-[12px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-yellow-500 tw-text-white tw-font-medium">
                                                {properties.filter((property) => property.status === "pending_review").length}
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handleTabChange("rejected")}
                                            className={`tw-px-2 md:tw-px-3 tw-py-1 tw-rounded-md tw-flex tw-gap-1 sm:tw-gap-2 tw-items-center tw-whitespace-nowrap tw-transition-all tw-duration-200 ${
                                                selectedTab === "rejected"
                                                    ? "tw-text-primary tw-font-semibold tw-border-b-2 tw-border-primary tw-bg-primary/5"
                                                    : "tw-text-black hover:tw-bg-gray-50"
                                            }`}
                                            aria-current={selectedTab === "rejected" ? "page" : undefined}
                                            role="tab"
                                            aria-selected={selectedTab === "rejected"}
                                        >
                                            Rejected
                                            <div className="tw-w-[18px] sm:tw-w-[20px] md:tw-w-[25px] tw-h-[18px] sm:tw-h-[20px] md:tw-h-[25px] tw-text-[10px] sm:tw-text-[12px] tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-red-500 tw-text-white tw-font-medium">
                                                {properties.filter((property) => property.status === "rejected").length}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="tw-hidden md:tw-flex tw-gap-2 lg:tw-gap-4 tw-items-center tw-flex-shrink-0">
                                    <p className="tw-text-nowrap tw-text-sm lg:tw-text-base">{currentProperties?.length} results</p>
                                    <button
                                        onClick={() => navigate("/list-property/welcome")}
                                        className="tw-py-2 tw-px-3 lg:tw-px-4 tw-text-nowrap tw-rounded-md tw-flex tw-justify-center tw-gap-2 tw-items-center tw-bg-secondary_hover hover:tw-bg-secondary tw-font-semibold tw-text-white tw-text-sm lg:tw-text-base"
                                    >
                                        List Now
                                        <GoArrowUpRight />
                                    </button>
                                </div>
                            </div>

                            {currentProperties ? (
                                <>
                                    {currentProperties.length > 0 ? (
                                        <section className="tw-px-5  tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-content-center xl:tw-grid-cols-4 2xl:tw-grid-cols-4 tw-gap-[1.5rem] 2xl:tw-gap-[2.5rem] tw-pb-20 tw-w-full">
                                            {currentProperties.map((itm, i) => (
                                                <PropertyComponent
                                                    key={i}
                                                    item={{
                                                        ...itm,
                                                        images: itm.images,
                                                    }}
                                                    setEditModal={() => {
                                                        let pendingProperty = completeProperties.filter(
                                                            (item) => item.pending_version?.property_id === itm?.property_id
                                                        )[0]?.pending_version;

                                                        setProperty(pendingProperty ?? itm);
                                                        setSelectedProperty(pendingProperty ?? itm);
                                                        setIsEdit(true);
                                                        setShowModal(true);
                                                    }}
                                                    isMyProperties={true}
                                                />
                                            ))}
                                        </section>
                                    ) : (
                                        <div className="tw-text-center tw-h-full tw-pt-40 tw-font-semibold tw-text-[24px] tw-text-gray-400 tw-w-full tw-flex tw-justify-center">
                                            <p>No Properties Found</p>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <section className="tw-px-5 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-content-center xl:tw-grid-cols-4 2xl:tw-grid-cols-4 tw-gap-[1.5rem] 2xl:tw-gap-[2.5rem] tw-pb-20 tw-w-full">
                                    {[...Array(4)].map((_, index) => (
                                        <PropertySkeleton key={index} />
                                    ))}
                                </section>
                            )}
                        </div>
                    )}

                    {properties && !loading && properties.length === 0 && <div className="mainContainer"></div>}
                    {isOpenhouseModal && <OpenHouseTimesModal property={property} onClose={() => setIsOpenhouseModal(false)} />}
                    {isShareModal && (
                        <div className="tw-fixed tw-z-[99999] tw-inset-0  tw-flex tw-items-center tw-justify-center">
                            <ShareComponent
                                selectedFile={{ url: `/public?propertyId=${isShareModal.property_id}` }}
                                property={isShareModal}
                                onClose={() => setIsShareModal(false)}
                            />
                        </div>
                    )}
                </div>
                <div className="tw-fixed  md:tw-hidden tw-bottom-5 tw-right-5  tw-flex tw-z-[999] tw-gap-4 max-sm:tw-flex-wrap tw-items-center">
                    <button
                        onClick={() => navigate("/list-property/welcome")}
                        className="tw-py-2 tw-px-4  max-sm:tw-w-full tw-text-nowrap tw-rounded-md tw-flex tw-justify-center tw-gap-2 tw-items-center tw-bg-secondary_hover hover:tw-bg-secondary tw-font-semibold tw-text-white "
                    >
                        List Now
                        <GoArrowUpRight />
                    </button>
                </div>
            </div>
            {showModal && property && (
                <EditProperty
                    property={property}
                    propertyCurrent={propertyCurrent}
                    setIsShareModal={setIsShareModal}
                    fetchProperties={fetchProperties}
                    setShowModal={setShowModal}
                    setProperty={setProperty}
                    completeProperties={completeProperties}
                    currentProperties={currentProperties}
                    setProperties={setProperties}
                    properties={properties}
                    selectedProperty={selectedProperty}
                />
            )}
        </>
    );
};

export default MyProperties;
